<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont1">{{ $t("p0322.editClassSchedule") }}</span>
    </p>
    <el-form
      class="systemFont2 systemForm1"
      ref="editorSchedulingFormRef"
      :model="editorSchedulingForm"
      label-width="106px"
      hide-required-asterisk
    >
      <el-row>
        <el-col :span="8" :offset="2">
          <!-- 领域 -->
          <el-form-item :label="$t('courseOption.field')">
            <el-select
              v-model="editorSchedulingForm.field"
              size="systemSelect3"
              style="width: 100%"
              disabled
              placeholder=""
            >
              <el-option
                :label="fieldOption.label"
                :value="fieldOption.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 课程名称 -->
          <el-form-item :label="$t('courseOption.courseName')">
            <el-input
              v-model="editorSchedulingForm.courseName"
              size="reportContentInput"
              :disabled="true"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <!-- 目标学员 -->
          <el-form-item
            :label="$t('courseOption.targetStudents')"
            class="formItem"
          >
            <el-input
              v-model="editorSchedulingForm.targetStudents"
              type="textarea"
              size="reportLongContentInput"
              rows="3"
              :disabled="true"
              maxlength="600"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <!-- 上课语言 -->
          <el-form-item :label="$t('courseOption.classLanguage')">
            <el-select
              v-model="editorSchedulingForm.classLanguage"
              size="systemSelect3"
              style="width: 100%"
              disabled
              placeholder=""
            >
            </el-select>
          </el-form-item>
          <!-- 证书 -->
          <el-form-item :label="$t('courseOption.certificate')">
            <el-input
              v-model="editorSchedulingForm.certificate"
              size="reportContentInput"
              :disabled="true"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <!-- 选择课程类型 -->
          <el-form-item style="text-align: left">
            <el-radio-group v-model="editorSchedulingForm.classType" disabled>
              <el-radio label="0">{{
                $t("courseOption.normalCourses")
              }}</el-radio>
              <el-radio label="1">{{
                $t("courseOption.freeCourses")
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 单价 -->
          <el-form-item :label="$t('schedulingAndPricing.unitPrice')">
            <el-col :span="11">
              <el-form-item
                label-width="0px"
                prop="unitPrice"
                :rules="unitPrice"
              >
                <el-input
                  :disabled="isdisabled2"
                  size="reportContentInput"
                  v-model="editorSchedulingForm.unitPrice"
                  maxlength="10"
                  :placeholder="$t('common.required')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
              <!-- 货币 -->
              <el-form-item label-width="0px">
                <el-select
                  v-model="editorSchedulingForm.currency"
                  size="systemSelect3"
                  style="width: 100%"
                  :disabled="isdisabled2"
                >
                  <el-option
                    v-for="item in currencyList"
                    :key="item.codeKey"
                    :label="item.codeValueZh"
                    :value="item.codeKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <!-- 形式 -->
          <el-form-item :label="$t('courseOption.form')">
            <el-select
              v-model="editorSchedulingForm.formCode"
              size="systemSelect3"
              style="width: 100%"
              :disabled="isdisabled ? true : false"
              placeholder=""
            >
              <el-option
                v-for="item in selection.filter(
                  item => item.searchKey === 'form' && item.codeKey !== '02'
                )"
                :key="item.codeKey"
                :label="item.codeValueZh"
                :value="item.codeKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 上课链接/视频链接 -->
          <el-form-item
            :label="
              formFlag
                ? $t('schedulingAndPricing.classLink')
                : $t('schedulingAndPricing.videoLink')
            "
            prop="classLink"
            :rules="classLink"
          >
            <el-input
              v-model="editorSchedulingForm.classLink"
              size="reportContentInput"
              maxlength="500"
              :disabled="isdisabled ? true : false"
            ></el-input>
          </el-form-item>
          <!-- 会议号 -->
          <el-form-item
            v-if="formFlag"
            :label="$t('schedulingAndPricing.meetingId')"
            prop="meetingId"
          >
            <el-input
              v-model="editorSchedulingForm.meetingId"
              size="reportContentInput"
              maxlength="500"
              :disabled="isdisabled ? true : false"
            ></el-input>
          </el-form-item>
          <!-- 会议密码/视频密码 -->
          <el-form-item
            :label="
              formFlag
                ? $t('schedulingAndPricing.linkPassword')
                : $t('schedulingAndPricing.videoPassword')
            "
            prop="linkPassword"
            :rules="linkPassword"
          >
            <el-input
              v-model="editorSchedulingForm.linkPassword"
              size="reportContentInput"
              maxlength="20"
              :disabled="isdisabled ? true : false"
            ></el-input>
          </el-form-item>
          <!-- 报名链接 -->
          <el-form-item
            :label="$t('schedulingAndPricing.signUpLink')"
            prop="signUpLink"
          >
            <el-input
              v-model="editorSchedulingForm.signUpLink"
              size="reportContentInput"
              maxlength="360"
              disabled
            >
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('p0321.requiredOptions')"
            style="text-align:left"
          >
            <el-checkbox
              v-model="editorSchedulingForm.signupSetting.sexIsRequired"
              :label="$t('p0321.title')"
              :disabled="isdisabled"
            ></el-checkbox>
            <el-checkbox
              v-model="editorSchedulingForm.signupSetting.phoneIsRequired"
              :label="$t('p0321.phone')"
              :disabled="isdisabled"
            ></el-checkbox>
            <el-checkbox
              v-model="editorSchedulingForm.signupSetting.companyIsRequired"
              :label="$t('p0321.company')"
              :disabled="isdisabled"
            ></el-checkbox>
            <el-checkbox
              v-model="editorSchedulingForm.signupSetting.positionIsRequired"
              :label="$t('p0321.position')"
              :disabled="isdisabled"
            ></el-checkbox>
            <el-checkbox
              v-if="editorSchedulingForm.classType !== '1'"
              v-model="editorSchedulingForm.signupSetting.birthdayIsRequired"
              :label="$t('p0321.birthday')"
              :disabled="isdisabled"
            ></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <div style="height: 445px"></div>
        </el-col>
        <el-col :span="8">
          <!-- 类别 -->
          <el-form-item :label="$t('courseOption.category')">
            <el-select
              v-model="editorSchedulingForm.category"
              size="systemSelect3"
              style="width: 100%"
              disabled
              placeholder=""
            >
              <el-option
                :label="categoryOption.label"
                :value="categoryOption.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 课程编号 -->
          <el-form-item :label="$t('courseOption.courseNumber')">
            <el-input
              v-model="editorSchedulingForm.courseNumber"
              size="reportContentInput"
              :disabled="true"
              maxlength="4"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <!-- 资格要求 -->
          <el-form-item
            :label="$t('courseOption.qualificationRequirements')"
            class="formItem"
          >
            <el-input
              v-model="editorSchedulingForm.qualificationRequirements"
              type="textarea"
              size="reportLongContentInput"
              rows="3"
              :disabled="true"
              maxlength="600"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <!-- 人数限制 -->
          <el-form-item :label="$t('courseOption.numberLimit')">
            <el-input
              v-model="editorSchedulingForm.numberLimit"
              size="reportContentInput"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <!-- 上课链接 -->
          <el-form-item :label="$t('courseOption.coursewareLink')">
            <el-input
              v-model="editorSchedulingForm.coursewareLink"
              size="reportContentInput"
              maxlength="500"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item style="height: 40px"></el-form-item>
          <!-- 课程时长想改成天+小时+分钟 -->
          <el-form-item
            :label="$t('courseOption.duration')"
            :rules="minutesRule"
            prop="minutes"
          >
            <el-row>
              <el-col :span="8">
                <el-select
                  filterable
                  v-model="days"
                  size="systemSelect3"
                  :disabled="isdisabled ? true : false"
                  style="width: calc(100% - 1.2rem);"
                  placeholder=""
                >
                  <el-option
                    v-for="item in dayList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                {{ $t("courseOption.days") }}
              </el-col>
              <el-col :span="8">
                <el-select
                  filterable
                  v-model="hours"
                  size="systemSelect3"
                  :disabled="isdisabled ? true : false"
                  style="width: calc(100% - 2rem);"
                  placeholder=""
                >
                  <el-option
                    v-for="item in hourList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                {{ $t("courseOption.hours") }}
              </el-col>
              <el-col :span="8">
                <el-select
                  filterable
                  v-model="minutes"
                  size="systemSelect3"
                  :disabled="isdisabled ? true : false"
                  style="width: calc(100% - 2rem);"
                  placeholder=""
                >
                  <el-option
                    v-for="item in durationList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                {{ $t("courseOption.minutes") }}
              </el-col>
            </el-row>
            <!-- <el-time-picker
              :disabled="nonEdit"
              v-model="detailForm.duration"
              format="HH:mm"
              value-format="HH:mm"
              :picker-options="{
                selectableRange: '00:01:00 - 04:00:00'
              }"
              @focus="timePickerFocus"
              @blur="timePickerBlur"
              size="systemTimeSelect"
              style="width: 100%"
              arrow-control
              :placeholder="$t('common.selectDuration')"
            >
            </el-time-picker> -->
          </el-form-item>
          <!-- 日期与时间 -->
          <el-form-item
            v-if="formFlag"
            :label="$t('schedulingAndPricing.dateAndTime')"
            prop="dateAndTime"
            :rules="dateAndTime"
          >
            <el-date-picker
              :disabled="isdisabled"
              v-model="editorSchedulingForm.dateAndTime"
              size="systemFormDate"
              style="width: 100%"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              :placeholder="$t('common.pleaseSelect')"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <!-- 日期与时间 -->
          <el-form-item
            v-if="formFlag"
            :label="$t('schedulingAndPricing.endDateAndTime')"
            prop="endDateAndTime"
            :rules="endDateAndTime"
          >
            <el-date-picker
              :disabled="isdisabled"
              v-model="editorSchedulingForm.endDateAndTime"
              size="systemFormDate"
              style="width: 100%"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              :placeholder="$t('common.pleaseSelect')"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <!-- 地点 -->
          <el-form-item
            v-if="formFlag"
            :label="$t('courseOption.classAddress')"
            prop="classAddress"
            :rules="editorSchedulingForm.formCode == '03' ? classAddress : [{ required: false }]"
          >
            <el-input
              v-model="editorSchedulingForm.classAddress"
              size="reportContentInput"
              maxlength="360"
              :disabled="isdisabled"
              :placeholder="editorSchedulingForm.formCode == '03' ? $t('common.required') : ''"
            ></el-input>
          </el-form-item>
          <!-- 老师 -->
          <el-form-item :label="$t('schedulingAndPricing.teachers')">
            <el-row
              v-for="(item, index) in editorSchedulingForm.teachersData"
              :key="index"
            >
              <el-form-item
                label-width="0px"
                :prop="`teachersData.${index}`"
                :rules="{
                  required: false,
                  validator: (rule, value, callback) => {
                    validateTeachers(rule, index, value, callback);
                  },
                  trigger: 'blur'
                }"
              >
                <el-select
                  v-model="editorSchedulingForm.teachersData[index]"
                  clearable
                  size="reportContentInput"
                  maxlength="20"
                  style="width:100%"
                  @change="teacherInputBlur(index)"
                  :disabled="isdisabled"
                >
                  <el-option
                    v-for="item in certifiedTrainersOptions"
                    :key="item.userId"
                    :label="item.lastName + item.firstName"
                    :value="item.userId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-form-item>
        </el-col>
        <!-- 加减按钮 -->
        <div :style="formFlag ? 'margin-top:446px' : 'margin-top: 365px'">
          <div
            v-show="buttonShow"
            v-for="(item, index) in editorSchedulingForm.teachersData"
            :key="index"
            style="height: 40px"
          >
            <img
              v-if="
                index == 0 &&
                  certifiedTrainersOptions.length >
                    editorSchedulingForm.teachersData.length
              "
              class="add-icon"
              src="@/assets/add.svg"
              @click="add()"
            />
            <img
              v-if="index != 0"
              class="subtract-icon"
              src="@/assets/subtract.svg"
              @click="subtract(index)"
            />
          </div>
        </div>
      </el-row>
    </el-form>
    <el-row
      class="foot-container"
      :style="
        isdisabled
          ? 'width: 24%;'
          : scheduleStatus
          ? 'width: 27%;'
          : 'width: 24%;'
      "
    >
      <el-col :span="isdisabled == true ? 12 : scheduleStatus ? 18 : 16">
        <!-- 编辑 -->
        <el-button
          v-if="isdisabled"
          type="submit"
          @click.native.prevent="handleEdit"
          >{{ $t("common.edit") }}</el-button
        >
        <el-col :span="scheduleStatus ? 8 : 12">
          <!-- 保存 -->
          <el-button
            v-if="!isdisabled"
            type="submit"
            @click.native.prevent="handleSave"
            >{{ $t("common.save") }}</el-button
          >
        </el-col>
        <el-col :span="scheduleStatus ? 8 : 12">
          <!-- 解除延期 -->
          <el-button
            v-if="!isdisabled && scheduleStatus"
            type="submit"
            @click.native.prevent="handleScheduleStatus"
            >{{ $t("p0324.postponementCancellation") }}</el-button
          >
        </el-col>
        <el-col :span="scheduleStatus ? 8 : 12">
          <!-- 删除 -->
          <el-button
            :disabled="deleteFlag"
            v-if="!isdisabled"
            type="submit"
            @click="handleDelete"
            >{{ $t("common.delete") }}</el-button
          >
        </el-col>
      </el-col>
      <el-col :span="isdisabled == true ? 12 : scheduleStatus ? 6 : 8">
        <el-button type="return" @click.native.prevent="handleReturn">{{
          $t("common.back")
        }}</el-button>
      </el-col>
      <!-- <el-dialog
        title=""
        width="400px"
        :visible.sync="deleteDialogVisible"
        >
        <span style="font-size: 16px;">{{$t('p0322.deleteEditClassSchedule')}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="return" @click="deleteDialogVisible = false">{{$t('common.cancel')}}</el-button>
          <el-button type="submit" @click="handleDelete">{{$t('common.confirm')}}</el-button>
        </span>
      </el-dialog> -->
    </el-row>
  </div>
</template>

<script>
import moment from "moment";
import qs from "qs";
export default {
  data() {
    var validateMinutes = (rule, value, callback) => {
      if (this.days + this.hours + this.minutes == 0) {
        callback(new Error(this.$t("courseOption.pleaseEnterDuration")));
      } else {
        callback();
      }
    };
    var dateAndTimeCheck = (rule, value, callback) => {
      if (!value) {
        // 请选择日期与时间
        return callback(
          new Error(this.$t("schedulingAndPricing.pleaseSelectDateAndTime"))
        );
      }
      this.$refs["editorSchedulingFormRef"].validateField("endDateAndTime");
      return callback();
    };
    var endDateAndTimeCheck = (rule, value, callback) => {
      if (!value) {
        // 请选择结束日期与时间
        return callback(
          new Error(this.$t("schedulingAndPricing.pleaseSelectEndDateAndTime"))
        );
      }
      let durations = String(
        Number(this.days * 24 * 60) +
        Number(this.hours * 60) +
        Number(this.minutes)
      );
      if (this.getDateDiff() <  durations) {
        return callback(
          // 结束日期与时间的间隔小于时长
          new Error(this.$t("schedulingAndPricing.msg1"))
        );
      } else {
        return callback();
      }
    };
    return {
      invalidTeacher: [],
      certifiedTrainersOptions: [],
      formVal: "",
      formFlag: false,
      // 课程时长想改成天+小时+分钟---zhc
      // 时分秒
      durationList: [],
      hourList: [],
      dayList: [],
      // 时长校验
      minutesRule: {
        trigger: ["blur", "change"],
        validator: validateMinutes,
        type: "number"
      },
      days: 0,
      hours: 0,
      minutes: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      // 老的表单数据
      oldEditorSchedulingForm: {},
      // 表单数据
      editorSchedulingForm: {
        field: "",
        category: "",
        courseNumber: "",
        courseName: "",
        targetStudents: "",
        qualificationRequirements: "",
        form: "",
        formCode: "",
        classLanguage: "",
        duration: "",
        numberLimit: "",
        certificate: "",
        coursewareLink: "",
        unitPrice: "",
        currency: "",
        meetingId: "",
        dateAndTime: "",
        endDateAndTime: "",
        classLink: "",
        linkPassword: "",
        teachers: "",
        teachersData: [""],
        signUpLink: "",
        // 老的日期与时间
        oldDateAndTime: "",
        oldEndDateAndTime: "",
        classAddress: "",
        oldClassAddress: "",
        classType: "",
        signupSetting: {
          sexIsRequired: true,
          phoneIsRequired: true,
          companyIsRequired: true,
          positionIsRequired: true,
          birthdayIsRequired: true
        }
      },
      // 领域下拉框选项
      fieldOption: {
        value: "",
        label: ""
      },
      // 类别下拉框选项
      categoryOption: {
        value: "",
        label: ""
      },
      // 选择项数据
      selection: [],
      currencyList: [],
      // 表单内容只读
      isdisabled: true,
      isdisabled2: true,
      // 判断是否延期
      scheduleStatus: true,
      // 加减按钮隐藏
      buttonShow: false,
      // 删除可否
      deleteFlag: false,
      // 删除对话框显示标志
      deleteDialogVisible: false,
      // 默认课程类型
      // classType: '',
      // 老师输入框的校验规则
      validateTeachers(rule, index, value, callback) {
        if (value) {
          let rules = /^[^,]+$/;
          if (!rules.test(value)) {
            return callback(
              new Error(this.$t("schedulingAndPricing.pleaseDoNotEnterCommas"))
            );
          } else {
            for (
              let i = 0;
              i < this.editorSchedulingForm.teachersData.length;
              i++
            ) {
              if (
                i != index &&
                this.editorSchedulingForm.teachersData[i] != ""
              ) {
                if (this.editorSchedulingForm.teachersData[i] == value) {
                  return callback(
                    new Error(
                      this.$t("schedulingAndPricing.duplicateMailboxExists")
                    )
                  );
                }
              }
            }
          }
        }
        callback();
      },
      unitPrice: [
        {
          required: true,
          message: this.$t("schedulingAndPricing.pleaseEnterUnitPrice"),
          trigger: "blur"
        },
        {
          pattern: /^(0|([1-9][0-9]*)(\.\d+)?|0(\.\d+)?)$/,
          message: this.$t("schedulingAndPricing.priceFormatIsIncorrect"),
          trigger: "blur"
        }
      ],
      classLink: [
        {
          required: false,
          message: this.$t("schedulingAndPricing.pleaseEnterClassLink"),
          trigger: "blur"
        },
        {
          pattern: /^(http|https):\/\/([\w-]+\.)+[\w-]+(\/[\w-./#?%&=]*)?$/,
          message: this.$t("schedulingAndPricing.linkFormatIsIncorrect"),
          trigger: "blur"
        }
      ],
      dateAndTime: [
        {
          validator: dateAndTimeCheck,
          trigger: "change"
        }
      ],
      endDateAndTime: [
        {
          validator: endDateAndTimeCheck,
          trigger: "change"
        }
      ],
      linkPassword: [
        {
          required: false,
          message: this.$t("schedulingAndPricing.pleaseEnterLinkPassword"),
          trigger: "blur"
        }
      ],
      classAddress: [
        {
          required: true,
          message: this.$t("schedulingAndPricing.pleaseInClassAddress"),
          trigger: "blur"
        }
      ]
    };
  },
  methods: {
    // 初始化
    init() {
      let url = "/api/classInvitation/initEditClassSchedule";
      let p0321 = JSON.parse(sessionStorage.getItem("p0321"));
      this.$http
        .post(url, {
          field: p0321.field,
          category: p0321.category,
          courseNumber: p0321.courseNumber,
          dateAndTime: p0321.dateAndTime
        })
        .then(response => {
          if (response.data.code === 200) {
            // console.log(response.data.data.meetingId);
            this.fieldOption.value = p0321.field;
            this.fieldOption.label = response.data.data.field;
            this.categoryOption.value = p0321.category;
            this.categoryOption.label = response.data.data.category;
            this.currencyList = response.data.data.currencyList;
            // this.editorSchedulingForm = response.data.data
            this.editorSchedulingForm.currency = response.data.data.currency;
            if (
              response.data.data.currency == null ||
              response.data.data.currency == ""
            ) {
              this.editorSchedulingForm.currency = "001";
            }
            this.editorSchedulingForm.unitPrice = response.data.data.unitPrice;
            this.editorSchedulingForm.field = p0321.field;
            (this.editorSchedulingForm.category = p0321.category),
              (this.editorSchedulingForm.courseNumber =
                response.data.data.courseNumber);
            this.editorSchedulingForm.courseName =
              response.data.data.courseName;
            this.editorSchedulingForm.targetStudents =
              response.data.data.targetStudents;
            this.editorSchedulingForm.qualificationRequirements =
              response.data.data.qualificationRequirements;
            this.editorSchedulingForm.form = response.data.data.form;
            this.editorSchedulingForm.classLanguage =
              response.data.data.classLanguage;
            this.editorSchedulingForm.duration = this.editDuration(
              response.data.data.duration
            );
            this.editorSchedulingForm.duration = response.data.data.duration;
            this.editorSchedulingForm.numberLimit =
              response.data.data.numberLimit;
            this.editorSchedulingForm.certificate =
              response.data.data.certificate;
            this.editorSchedulingForm.coursewareLink =
              response.data.data.coursewareLink;
            this.editorSchedulingForm.dateAndTime =
              response.data.data.dateAndTime;
            this.editorSchedulingForm.endDateAndTime =
              response.data.data.endDateAndTime;
            this.editorSchedulingForm.classLink = response.data.data.classLink;
            this.editorSchedulingForm.meetingId = response.data.data.meetingId;
            this.editorSchedulingForm.linkPassword =
              response.data.data.linkPassword;
            this.editorSchedulingForm.oldScheduleStatus =
              response.data.data.scheduleStatus;
            this.editorSchedulingForm.scheduleStatus =
              response.data.data.scheduleStatus;
            this.scheduleStatus =
              this.editorSchedulingForm.scheduleStatus === 2 ? true : false;
            this.invalidTeacher = response.data.data.invalidTeacher;
            if (
              this.invalidTeacher != null &&
              typeof this.invalidTeacher != "undefined" &&
              this.invalidTeacher != ""
            ) {
              {
                this.open();
              }
            }
            if (
              response.data.data.teachersData != null &&
              response.data.data.teachersData.length > 0
            ) {
              this.editorSchedulingForm.teachersData =
                response.data.data.teachersData;
            }
            this.editorSchedulingForm.signupSetting = response.data.data
              .signupSetting
              ? response.data.data.signupSetting
              : this.editorSchedulingForm.signupSetting;
            this.editorSchedulingForm.signUpLink =
              response.data.data.signUpLink;
            this.editorSchedulingForm.oldDateAndTime = this.editorSchedulingForm.dateAndTime;
            this.editorSchedulingForm.oldEndDateAndTime = this.editorSchedulingForm.endDateAndTime;
            this.deleteFlag = response.data.data.deleteFlag;
            this.editorSchedulingForm.classAddress =
              response.data.data.classAddress;
            this.editorSchedulingForm.oldClassAddress =
              response.data.data.classAddress == null
                ? ""
                : response.data.data.classAddress;
            this.editorSchedulingForm.classType = response.data.data.classType;
            // console.log("response.data.data",response.data.data)
            this.editorSchedulingForm.formCode = response.data.data.formCode;
            this.formFlag = this.editorSchedulingForm.formCode != "02";
            this.formVal = response.data.data.formCode;
            this.oldEditorSchedulingForm = JSON.stringify(
              this.editorSchedulingForm
            );
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    async initCourseOption(){
      await this.$http
        .post('/api/courseOption/init')
        .then(response => {
          if (response.data.code === 200) {
            this.selection = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    open() {
      this.$alert(
        this.$t("p0324.msg1") + this.invalidTeacher + this.$t("p0324.msg2"),
        this.$t("common.tips"),
        {
          confirmButtonText: this.$t("common.confirm"),
          callback: action => {}
        }
      );
    },
    // 获取认证老师
    getCertifiedTrainers() {
      let url = "/api/schedulingAndPricing/certifiedTrainers";
      let p0321 = JSON.parse(sessionStorage.getItem("p0321"));
      this.$http
        .post(url, {
          field: p0321.field,
          category: p0321.category,
          courseNumber: p0321.courseNumber
        })
        .then(response => {
          if (response.data.code === 200) {
            this.certifiedTrainersOptions = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 新增老师
    add() {
      if (this.editorSchedulingForm.teachersData.length == 10) {
        return;
      }
      this.editorSchedulingForm.teachersData.push("");
    },

    // 删减老师
    subtract(index) {
      this.editorSchedulingForm.teachersData.splice(index, 1);
      let that = this;
      this.editorSchedulingForm.teachersData.forEach(function(
        value,
        index,
        array
      ) {
        that.$refs.editorSchedulingFormRef.validateField(
          `teachersData.${index}`
        );
      });
    },

    // 老师输入框光标移出
    teacherInputBlur(param) {
      let that = this;
      this.editorSchedulingForm.teachersData.forEach(function(
        value,
        index,
        array
      ) {
        if (param != index) {
          that.$refs.editorSchedulingFormRef.validateField(
            `teachersData.${index}`
          );
        }
      });
      that.$refs.editorSchedulingFormRef.validateField(`teachersData.${param}`);
    },
    // 编辑
    handleEdit() {
      if (this.editorSchedulingForm.classType != 1) {
        (this.isdisabled = false),
          (this.buttonShow = true),
          (this.isdisabled2 = false);
      } else {
        (this.isdisabled = false),
          (this.buttonShow = true),
          (this.isdisabled2 = true);
      }
    },
    // 比较数据是否发生变更
    isContentChanged() {
      let durations = String(
        Number(this.days * 24 * 60) +
        Number(this.hours * 60) +
        Number(this.minutes)
      );
      console.log(JSON.parse(this.oldEditorSchedulingForm))
      if (
        this.oldEditorSchedulingForm ===
        JSON.stringify(this.editorSchedulingForm) && JSON.parse(this.oldEditorSchedulingForm).duration === durations
      ) {
        this.$message({
          message: this.$t("common.contentIsUnchanged"),
          type: "warning"
        });
        return true;
      }
      return false;
    },
    // 获取分钟
    getDurationList() {
      for (let i = 0; i < 60; i++) {
        this.durationList.push(i);
      }
    },
    // 获取小时
    getHours() {
      for (let i = 0; i < 12; i++) {
        this.hourList.push(i);
      }
    },
    // 获取天
    getDayList() {
      this.dayList.push(0);
      for (let i = 1; i <= 10; i = i + 0.5) {
        this.dayList.push(i);
      }
    },
    // 取得日期时间差
    getDateDiff() {
      if (
        this.editorSchedulingForm.dateAndTime == null ||
        this.editorSchedulingForm.dateAndTime == ""
      ) {
        return 0;
      }
      let startDate = parseInt(
        new Date(this.editorSchedulingForm.dateAndTime).getTime() /
          (1000 * 60 * 60 * 24)
      );
      let endDate = parseInt(
        new Date(this.editorSchedulingForm.endDateAndTime).getTime() /
          (1000 * 60 * 60 * 24)
      );
      return (endDate - startDate + 1) * 24 * 60;
    },
    // 如果是延期恢复
    handleScheduleStatus() {
      this.$confirm(this.$t("p0324.msg4"), this.$t("common.tips"), {
        confirmButtonText: this.$t("common.confirm"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      })
        .then(() => {
          // 如果是延期恢复
          if (this.scheduleStatus) {
            // 获取当前时间
            var currTime = new Date();

            // 设置当前时间的小时、分钟、秒和毫秒为0
            currTime.setHours(0);
            currTime.setMinutes(0);
            currTime.setSeconds(0);
            currTime.setMilliseconds(0);
            // 大于当天0点的时间
            // 将 this.editorSchedulingForm.dateAndTime 转换为 Date 对象
            var dateAndTime = new Date(this.editorSchedulingForm.dateAndTime);
            if (dateAndTime < currTime) {
              return this.$message({
                message: this.$t("p0324.msg3"),
                type: "warning"
              });
            } else {
              this.editorSchedulingForm.scheduleStatus = 1;
              // 保存
              this.handleSave();
            }
          }
        })
        .catch(() => {});
    },

    // 保存
    handleSave() {
      if (this.isContentChanged()) {
        return;
      }
      this.$refs["editorSchedulingFormRef"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container")
          });
          let url = "/api/classInvitation/handleSaveEditClassSchedule";
          // 初始化老师的数据
          this.editorSchedulingForm.teacherUserIds = this.editorSchedulingForm.teachersData[0];
          // 循环拼接剩余的老师
          for (
            let i = 1;
            i < this.editorSchedulingForm.teachersData.length;
            i++
          ) {
            if (
              this.editorSchedulingForm.teachersData.length > 1 &&
              this.editorSchedulingForm.teachersData[i] != ""
            ) {
              this.editorSchedulingForm.teacherUserIds +=
                "," + this.editorSchedulingForm.teachersData[i];
            }
          }
          this.editorSchedulingForm.teachers = this.editorSchedulingForm.teachersData
            .filter(userId => userId !== "")
            .map(userId => {
              const teacher = this.certifiedTrainersOptions.find(
                teacher => teacher.userId === userId
              );
              return teacher ? `${teacher.lastName}${teacher.firstName}` : "";
            })
            .filter(name => name !== "")
            .join(",");
          this.editorSchedulingForm.dateAndTime = moment(
            this.editorSchedulingForm.dateAndTime
          ).format("YYYY-MM-DD HH:mm:00");
          console.log(
            "this.editorSchedulingForm.dateAndTime",
            this.editorSchedulingForm.dateAndTime
          );
          this.editorSchedulingForm.endDateAndTime = moment(
            this.editorSchedulingForm.endDateAndTime
          ).format("YYYY-MM-DD HH:mm:00");
          console.log(
            "this.editorSchedulingForm.endDateAndTime",
            this.editorSchedulingForm.endDateAndTime
          );
          this.editorSchedulingForm.userId = localStorage.getItem("userId");
          this.editorSchedulingForm.classLink = this.editorSchedulingForm.classLink.trim();
          this.editorSchedulingForm.meetingId = this.editorSchedulingForm.meetingId.trim();
          this.editorSchedulingForm.coursewareLink = this.editorSchedulingForm.coursewareLink.trim();
          this.editorSchedulingForm.signUpLink = this.editorSchedulingForm.signUpLink.trim();
          this.editorSchedulingForm.linkPassword = this.editorSchedulingForm.linkPassword.trim();
          this.editorSchedulingForm.classAddress = this.editorSchedulingForm.classAddress;
          this.editorSchedulingForm.classType = this.editorSchedulingForm.classType;
          let durations = String(
            Number(this.days * 24 * 60) +
            Number(this.hours * 60) +
            Number(this.minutes)
          );
          this.editorSchedulingForm.duration = durations
          this.$http
            .post(url, this.editorSchedulingForm)
            .then(response => {
              if (response.data.code === 200) {
                (this.isdisabled = true),
                  (this.isdisabled2 = true),
                  (this.buttonShow = false);
                this.editorSchedulingForm.oldDateAndTime = this.editorSchedulingForm.dateAndTime;
                this.editorSchedulingForm.oldEndDateAndTime = this.editorSchedulingForm.endDateAndTime;
                loading.close();
                this.$message.success(response.data.data);
                let p0321 = JSON.stringify({
                  field: this.editorSchedulingForm.field,
                  category: this.editorSchedulingForm.category,
                  courseNumber: this.editorSchedulingForm.courseNumber,
                  courseName: this.editorSchedulingForm.courseName,
                  dateAndTime: this.editorSchedulingForm.dateAndTime
                });
                sessionStorage.p0321 = p0321;
                this.init();
              } else {
                loading.close();
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },
    // 删除
    handleDelete() {
      this.$confirm(this.$t("p0322.deleteEditClassSchedule"), {
        // 确定
        confirmButtonText: this.$t("common.confirm"),
        // 取消
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container")
          });
          let url = "/api/classInvitation/handleDeleteEditClassSchedule";
          this.$http
            .post(url, this.editorSchedulingForm)
            .then(response => {
              if (response.data.code === 200) {
                this.$router.push({
                  path: "/views/GreenJacketForum/P0321"
                });
                loading.close();
                this.$message.success(response.data.data);
              } else {
                loading.close();
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        })
        .catch(() => {});
    },
    // 返回
    handleReturn() {
      this.$router.push({
        path: "/views/GreenJacketForum/P0321",
        query: {
          dateAndTime: this.$route.query.dateAndTime,
          courseName: this.$route.query.courseName,
          currentPageCo: this.$route.query.currentPageCo,
          scheduleStatus: this.$route.query.scheduleStatus,
          totalCo: this.$route.query.totalCo,
          pageSizeCo: this.$route.query.pageSizeCo
        }
      });
    },

    // 编辑上课时长
    editDuration(value) {
      // 课程时长想改成天+小时+分钟---zhc
      let minuteTest = Number(value);
      // 取到分钟数
      let day = parseInt(minuteTest / 60 / 24 / 0.5) * 0.5;
      let hour = parseInt(minuteTest / 60 - day * 24);
      let min = parseInt(minuteTest - day * 24 * 60 - hour * 60);
      if (day > 0) {
        this.days = day;
      }
      if (hour > 0) {
        this.hours = hour;
      }
      if (min > 0) {
        this.minutes = min;
      }
    }
  },
  async mounted() {
    await this.initCourseOption();
    this.init();
    this.getCertifiedTrainers();
    this.getDurationList();
    this.getHours();
    this.getDayList();
  }
};
</script>

<style lang="scss" scoped>
.foot-container {
  margin: 0 auto;
  height: 26px;
  width: 24%;
  text-align: center;
}

// el-form-item的label的行高度
.formItem >>> .el-form-item__label {
  line-height: 24px;
}

// 加号图标的样式
.add-icon {
  float: left;
  position: relative;
  top: 13px;
  left: 10px;
  cursor: pointer;
}

// 减号图标的样式
.subtract-icon {
  float: left;
  position: relative;
  top: 18px;
  left: 9px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0324.vue